import React, { memo } from 'react'

import PageHeaderWrapper from 'wrappers/PageHeaderWrapper'

const RedeemHeading = ({ label, ...restProps }) => {
  return <PageHeaderWrapper label={label} header {...restProps} />
}

export default memo(RedeemHeading)
